import { useEffect, useState } from "react";
import { apiListProducts } from "../lib/api";

let cached = null;
let cachePromise = null;

export const fetchProducts = async () => {
  if (cached) return cached;
  if (!cachePromise) {
    cachePromise = apiListProducts()
      .then((data) => {
        cached = data;
        return data;
      })
      .catch(() => {
        cachePromise = null;
        return [];
      });
  }
  return cachePromise;
};

export const invalidateProducts = () => { cached = null; cachePromise = null; };

export const useProducts = () => {
  const [items, setItems] = useState(cached || []);
  const [loading, setLoading] = useState(!cached);
  useEffect(() => {
    let mounted = true;
    fetchProducts().then((data) => {
      if (mounted) { setItems(data); setLoading(false); }
    });
    return () => { mounted = false; };
  }, []);
  return { items, loading };
};
